import { render, staticRenderFns } from "./ChatFrame.vue?vue&type=template&id=781f8e22&scoped=true&"
import script from "./ChatFrame.vue?vue&type=script&lang=js&"
export * from "./ChatFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f8e22",
  null
  
)

export default component.exports